import { useApi } from '../../api/api-context';
import { useQueryMutation } from '../../api/use-query-mutation';
import { useBudgetId } from '../../budget/budget-store';
import { TransactionType } from './transaction-types';
import { logAndThrowError } from '../../utils/errors';
export const useCreateTransactionApi = (options) => {
    const api = useApi();
    const budgetId = useBudgetId();
    const queryKey = ['transactions', budgetId];
    // api call
    const createTransactionApi = async (data) => {
        await api.post('/account/transaction', data);
    };
    // optimistic update
    const onMutate = (oldData, request) => {
        const newTransactions = oldData ? [...oldData] : [];
        const transactionId = request.id;
        const newTransaction = { ...request, id: transactionId };
        newTransactions.push(newTransaction);
        // handle transfer transactions
        if (request.type === TransactionType.TRANSFER && request.transferAccountId) {
            const transferTransactionId = request.transferTransactionId;
            if (!transferTransactionId) {
                logAndThrowError('Transfer transaction id required');
            }
            const transferTransaction = {
                ...request,
                id: transferTransactionId,
                budgetId: request.budgetId,
                accountId: request.transferAccountId,
                transferAccountId: request.accountId,
                transferTransactionId: transactionId,
                dateEpoch: request.dateEpoch,
                inflow: request.outflow,
                outflow: request.inflow,
            };
            newTransactions.push(transferTransaction);
        }
        newTransactions.sort((a, b) => b.dateEpoch - a.dateEpoch || b.id.localeCompare(a.id));
        return newTransactions;
    };
    return useQueryMutation(createTransactionApi, queryKey, onMutate, options);
};
